import { render, staticRenderFns } from "./SliderProduct.vue?vue&type=template&id=41f22a8e&scoped=true&"
import script from "./SliderProduct.vue?vue&type=script&lang=js&"
export * from "./SliderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f22a8e",
  null
  
)

export default component.exports